
export default {
  name: 'MailUs',
  computed: {
    emailAddress() {
      return this.$i18n('reservation.mail-us-address');
    },
  },
};
